// types of action to dispatch
export const Types= {
    LOAD_ALL_SERVICES: "GET_ALL_SERVICES_SUCCESS",
    LOAD_KYC_SERVICES: "GET_KYC_SERVICES_SUCCESS",
    LOAD_KYB_SERVICES: "GET_KYB_SERVICES_SUCCESS",
    ALL_KYC_SELECTED: "ALL_KYC_SERVICES_SELECTED",
    SOME_KYC_SELECTED: "SOME_KYC_SERVICES_SELECTED",
    ALL_KYB_SELECTED: "ALL_KYB_SERVICES_SELECTED",
    SOME_KYB_SELECTED: "SOME_KYB_SERVICES_SELECTED",
    TOGGLE_KYC_SORT: "TOGGLE_KYC_SORT",
    TOGGLE_KYB_SORT: "TOGGLE_KYB_SORT",
    KYC_GLOBAL_SEARCH: "KYC_GLOBAL_SEARCH",
    KYB_GLOBAL_SEARCH: "KYB_GLOBAL_SEARCH",

    SET_KYC_FILTER: "SET_KYC_FILTER",
    SET_KYB_FILTER: "SET_KYB_FILTER",

    FILTER_SERVICES: "FILTERED_BY_SELECTED_VALUE",
    FILTER_KYB_SERVICES: "FILTERED_KYB_BY_SELECTED_VALUE",
    FILTER_KYC_SERVICES: "FILTERED_KYC_BY_SELECTED_VALUE",

    CLEAR_SERVICES: "CLEAR_SERVICES",
};

// type of services requested
export const ServiceTypes = {
    KYC: "kyc",
    KYB: "kyb",
    KYB_SUB_TYPE: {
        BV: "bv",
        ODO: "odo",
        KYB: "kyb",
        ALL: "all",
    }
};

export const SortFields = {
    SERVICE_NAME: "service_name",
    STATUS: "integration_status",
    LAST_UPDATED: "last_updated",
}
